import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createPopper } from '@popperjs/core';
import React, { useLayoutEffect } from 'react';
export function usePopper(props) {
  var _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      offsetProp = props.offset,
      _props$preventOverflo = props.preventOverflow,
      preventOverflow = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$forceUpdate = props.forceUpdate,
      forceUpdate = _props$forceUpdate === void 0 ? true : _props$forceUpdate,
      _props$flip = props.flip,
      flip = _props$flip === void 0 ? true : _props$flip,
      _props$eventsEnabled = props.eventsEnabled,
      eventsEnabled = _props$eventsEnabled === void 0 ? true : _props$eventsEnabled,
      _props$modifiers = props.modifiers,
      modifiers = _props$modifiers === void 0 ? [] : _props$modifiers;
  var popper = React.useRef(null);
  var referenceRef = React.useRef(null);
  var popoverRef = React.useRef(null);

  var _React$useState = React.useState(initialPlacement),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      originalPlacement = _React$useState2[0],
      place = _React$useState2[1];

  var _React$useState3 = React.useState(initialPlacement),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      placement = _React$useState4[0],
      setPlacement = _React$useState4[1];

  var _React$useState5 = React.useState(offsetProp || [0, 0]),
      _React$useState6 = _slicedToArray(_React$useState5, 1),
      offset = _React$useState6[0];

  var _React$useState7 = React.useState({}),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      popoverStyles = _React$useState8[0],
      setPopoverStyles = _React$useState8[1];

  var update = React.useCallback(function () {
    if (popper.current) {
      popper.current.forceUpdate();
      return true;
    }

    return false;
  }, []);
  useLayoutEffect(function () {
    if (referenceRef.current && popoverRef.current) {
      popper.current = createPopper(referenceRef.current, popoverRef.current, {
        placement: originalPlacement,
        strategy: fixed ? 'fixed' : 'absolute',
        modifiers: [{
          name: 'eventListeners',
          enabled: eventsEnabled
        }, {
          name: 'applyStyles',
          enabled: false
        }, {
          name: 'flip',
          enabled: flip,
          options: {
            padding: 8
          }
        }, {
          name: 'computeStyles',
          options: {
            gpuAcceleration: false,
            adaptive: false
          }
        }, {
          name: 'offset',
          options: {
            offset: offset
          }
        }, {
          name: 'preventOverflow',
          enabled: preventOverflow
        }, {
          name: 'updateState',
          phase: 'write',
          enabled: true,
          fn: function fn(_ref) {
            var state = _ref.state;
            setPlacement(state.placement);
            setPopoverStyles(state.styles.popper);
          }
        }].concat(_toConsumableArray(modifiers))
      });
    }

    return function () {
      if (popper.current) {
        popper.current.destroy();
        popper.current = null;
      }
    };
  }, [originalPlacement, fixed, forceUpdate, flip, offset, preventOverflow, eventsEnabled]);
  useLayoutEffect(function () {
    var id = requestAnimationFrame(function () {
      if (forceUpdate) {
        if (popper.current) {
          popper.current.forceUpdate();
        }
      }
    });
    return function () {
      cancelAnimationFrame(id);
    };
  }, [forceUpdate]);
  return {
    popperInstance: popper.current,
    reference: {
      ref: referenceRef
    },
    popper: {
      ref: popoverRef,
      style: popoverStyles
    },
    update: update,
    placement: placement,
    place: place
  };
}